angular.module('mtic')
.service('StudentDataService', function (
  DEV_VARIABLES,
  GLOBAL_API_CONFIG,
  ASSET_HOST,
  ITEM_VERSION_MAP,
  EventManager,
  Firebase,
  api,
  userAccount,
  $q,
  $log,
  DataCacheService,
  DataPathService,
  FirebaseItematic,
  apiMethods,
  moduleMappingService
) {
  var eventManager = new EventManager('StudentDataService')
  /**
  * Private vars
  */
  var studentModuleMaps = {};
  var classModuleMaps = {};
  var classSummaryStats = {};

  var resetMaps = function () {
    studentModuleMaps = {};
    classModuleMaps = {};
    classSummaryStats = {};
  }

  var getUserIDSync = function(){
    return userAccount.getData().user_id;
  }

  /**
  * Public Methods
  * @type {Object}
  */
  var StudentDataService = {
    genUrlfromContent: function(slug, content) {
      return determineHostUrl({
        slug: slug,
        content: content,
      })
    },
    /**
    * Get Module Data
    * @param  {Boolean} refresh get new module data if set to true
    * @return {Promise}
    */
    getModuleData: function (refresh) {
      switch (userAccount.getData().role.role_type) {
        case 'mtic_student': return getStudentMaps(refresh);
        case 'mtic_teacher': throw "Invalid Account Type"
        default:             throw 'Invalid role!'
      }
    },

    getCustomResource: function(resourceId){
      return api.getStudentCustomResource(resourceId).then(function(groupData){
        // $log.log('got group data : ', groupData)
        var customResource = groupData[0]//groupData.CustomModule.Resource.children[0];
        customResource.locked = false;
        customResource.hostUrl = determineHostUrl(customResource)
        return customResource;
      });
    },

    getClassInfo({class_id}){
      return api.getClassInfo({class_id});
    },

    getUserSchools: function(cb, reset){
      return DataCacheService.fetch({
        action: cb,
        reset,
        key: DataPathService['user/schools']( getUserIDSync() ),
        fetcher: function(cb){
          // console.log(userAccount.getData())
          var schools = userAccount.getData().roles.filter(function(role) {
            return role.group.group_type === 'school' || role.group.group_type === 'no_school';
          }).map(function(role) {
            return role.group
          })
          cb(schools);
        },
      });
    },

    getAgendas: function(){
      if(userAccount.getData().role.isTeacher){
        return [];
      }
      return api.getStudentAgenda()
      .then(function(data){
        return data.Agendas ? data.Agendas : [];
      });
    },

    getClassMembers: function(){
      return api.getStudentClassMembers()
    },
    getClassMembersMap: function(){
      return this.getClassMembers().then(function(students){
        var studentMap = {};
        _.each(students, function(student){
          studentMap[student.user_id] = angular.copy(student);
          studentMap[student.user_id].display_name = [
            studentMap[student.user_id].info.first_name,
            studentMap[student.user_id].info.last_name
          ].join(' ')
        })
        return studentMap;
      })
    },

    transferStudent({teacher_id, from_class_id, to_class_id}){
      return api.transferStudent({
        teacher_id,
        from_class_id,
        to_class_id
      })
    },

    parseClassCode(classCode){
      var classCodeSplit = classCode.toLowerCase().split('c');
      return {
        teacherId: classCodeSplit[0],
        classId: classCodeSplit[1]
      }
    },

    setActiveClassroom(class_group_id){
      userAccount.setActiveClassroom(class_group_id);
      api.setGroupId(class_group_id);
    },

    getClasses(){
      //return language.get(moduleResource.slug);
      return api.getClassesForStudent().then((allClasses) => new Promise((resolve) => {
        const allPromises = [];
        _.each(allClasses, (singularClass) => {
          allPromises.push(StudentDataService.getCountry(singularClass.id).then((country) => {
            singularClass.country = country;
          }));
        });
        Promise.all(allPromises).then(() => resolve(allClasses));
      }));
    },

    getCurrentUserData: function(){
      var userData = userAccount.getData();
      // userAccount.setActiveClassroom(userData.role.group_id)
      return {
        user_id: userData.user_id,
        firstName: userData.firstName,
        lastName: userData.lastName,
        fullName: userData.fullName,
        // class_id: userData.role.group_id
        // class_id: userAccount.getActiveClassroom()
      }
    },
    getClassCommentState: function(resourceId) {
      // var componentStates = {};
      // return componentStates;
      // return $q.all([
      //   Firebase.database().ref([
      //     'classCommentHistory',
      //     this.getCurrentClassId(),
      //     resourceId
      //   ].join('/')).once('value'),
      //   this.getClassMembersMap()
      // ]).then(function(datas){
      //   var states = datas[0].val();
      //   var classMembers = datas[1];
      //   var componentStates = {};
      //   _.forEach(states, function(obj, key){
      //     if(!componentStates[obj.component_id]) {
      //       componentStates[obj.component_id] = {comments:[]};
      //     }
      //     var componentState = componentStates[obj.component_id];
      //     var comment = angular.copy(obj.state || {});
      //     comment['.key'] = key;
      //     comment.time = obj.time_stamp;
      //     comment.author = classMembers[obj.user_id].display_name;
      //     componentState.comments.push(comment)
      //   })
      //   _.forEach(componentStates,function(state){
      //     state.comments = state.comments.sort(function(a,b){
      //       return b.time - a.time;
      //     })
      //   })
      //   return componentStates;
      // })
    },
    /**
     * Gets the country of the class.
     * Please refer to groups.groupType == 'country' in the db for what country names its expecting
     * If updating this, please update the `getCountry` in mtic2\src\main\services\TeacherDataService.js as well :/
     * @param {number} class_id
     * @returns {(string|null)}
     */
    getCountry: function(class_id) {
      return DataCacheService.fetch({
        key: DataPathService.dynamic('class/country/:classId', { classId: class_id }),
        fetcher: function(next) {
          return api.getCountryOfClass(class_id).then(function(data) {
            if (data) {
              next(data.name)
            } else {
              next(null);
            }
          });
        }
      });
    },
  };

  /**
  * Listens to session expired event
  */
  eventManager.listen('login:session:expired', function () {
    resetMaps();
  });
  /**
  * Listens to logout event
  */
  eventManager.listen('logout', function () {
    resetMaps();
  });

  eventManager.listen('navbar:my-classes:click', function () {
    resetMaps();
  })

  /**
  * Determine the url for openfl items
  * @param  {String} slug
  * @param  {String} itemVersion
  * @return {String}
  */
  var determineURLForOpenFl = function (slug, itemVersion) {
    if (!GLOBAL_API_CONFIG.IGNORE_ITEM_VERSION_MAP && ITEM_VERSION_MAP[slug]) {
      var item_version = ITEM_VERSION_MAP[slug];
      if(slug === 'run_like_math' && userAccount.getData().role.isTeacher){
        item_version = ITEM_VERSION_MAP.run_like_math_teacher;
      }
      // $log.log('[[determineURLForOpenFl]]','Using ITEM_VERSION_MAP item version for', slug, ', i.e. using local file');
      return ASSET_HOST.CONTAINER.openfl.URL +
      "?versionId=" +
      ASSET_HOST.CONTAINER.openfl.VERSION +
      '&mticItemId=' +
      slug +
      '&mticItemVersion=' + item_version;
    } else
    if (itemVersion) {
      // $log.log('[[determineURLForOpenFl]]','Using fed-in itemVersion', slug, ', ', itemVersion);
      return ASSET_HOST.CONTAINER.openfl.URL +
      "?versionId=" + ASSET_HOST.CONTAINER.openfl.VERSION +
      '&mticItemId=' + slug +
      '&mticItemVersion=' + itemVersion;
    } else {
      $log.warn('Missing item version for', slug, 'reverting to latest');
      return ASSET_HOST.CONTAINER.openfl.URL +
      "?versionId=" +
      ASSET_HOST.CONTAINER.openfl.VERSION +
      '&mticItemId=' +
      slug;
    }
  }

  var determineURLForCycle4Html = function (slug, itemVersion) {
    if (!GLOBAL_API_CONFIG.IGNORE_ITEM_VERSION_MAP && ITEM_VERSION_MAP[slug]) {
      var item_version = ITEM_VERSION_MAP[slug];
      return ASSET_HOST.CONTAINER.openfl_c4.URL +
      "?versionId=" +
      ASSET_HOST.CONTAINER.openfl_c4.VERSION +
      '&mticItemId=' +
      slug +
      '&mticItemVersion=' + item_version;
    } else
    if (itemVersion) {
      // $log.log('[[determineURLForopenfl_c4]]','Using fed-in itemVersion', slug, ', ', itemVersion);
      return ASSET_HOST.CONTAINER.openfl_c4.URL +
      "?versionId=" + ASSET_HOST.CONTAINER.openfl_c4.VERSION +
      '&mticItemId=' + slug +
      '&mticItemVersion=' + itemVersion;
    } else {
      $log.warn('Missing item version for', slug, 'reverting to latest');
      return ASSET_HOST.CONTAINER.openfl_c4.URL +
      "?versionId=" +
      ASSET_HOST.CONTAINER.openfl_c4.VERSION +
      '&mticItemId=' +
      slug;
    }
  }

  /**
  * Determine the url for cycle4 items
  * @param  {String} slug
  * @return {String}
  */
  var determineURLForCycle4 = function (slug, content) {
    var item_type = content.openfl ? 'mathematic_maker' : 'activity';
    return ASSET_HOST.CONTAINER.c4swf.URL + '?versionId=' + ASSET_HOST.CONTAINER.c4swf.VERSION;
  }


  /**
  * Determine the url for an inbook package
  * @param  {String} repo
  * @param  {String} cloudfrontVersion
  * @return {String}
  */
  var determineURLForInbook = function(repo, cloudfrontVersion) {
    var URL = ASSET_HOST.CONTAINER.inbook_package.URL +
    '?versionId=' + ASSET_HOST.CONTAINER.inbook_package.VERSION +
    '&host=cloudfront' +
    '&repo=' + repo +
    '&repoVersion=';
    if (!GLOBAL_API_CONFIG.IGNORE_ITEM_VERSION_MAP && ITEM_VERSION_MAP[repo]) {
      return URL + ITEM_VERSION_MAP[repo];
    } else {
      return URL + cloudfrontVersion;
    }
  }

  /**
  * Determine the url for an itematic package
  * @param  {String} slug
  * @param  {String} version
  * @param  {String} type
  * @param  {String} key
  * @return {String}
  */
  var determineURLForItematic = function(slug, groupId, groupItemId, itemVersionId) {
    return 'itematic://' + ['slug', slug, 'groupId', groupId, 'groupItemId', groupItemId, 'itemVersionId', itemVersionId].join('/') ;
  }

  /**
  * Determine the url for a custom link
  * @return {String}
  */
  var determineURLForLink = function(content) {
    var URL = '';
    var currentProtocol = window.location.protocol;
    $log.debug('[[StudentDataService]] determineURLForLink',content)
    if('value' in content) {
      URL = content.value.replace(/^(http|https):/i,currentProtocol)
    }else{
      URL = currentProtocol + '//aotw-pd.s3.amazonaws.com/media-vimeo/70533052.jpg'
    }
    $log.debug('[[StudentDataService]] determineURLForLink',content, URL)
    return URL;
  }

  /**
  * Determine URL path for HTML package
  * @param  {String} itemSlug
  * @param  {String} itemVersion
  * @return {String}
  */
  var determineURLForHTMLPackage = function (itemSlug, itemVersion) {
    if (!GLOBAL_API_CONFIG.IGNORE_ITEM_VERSION_MAP && ITEM_VERSION_MAP[itemSlug]) {
      return ASSET_HOST.CONTAINER.html_package.URL + '/' + itemSlug + '/' + ITEM_VERSION_MAP[itemSlug] + '/index.html'
    } else {
      return ASSET_HOST.CONTAINER.html_package.URL + '/' + itemSlug + '/' + itemVersion + '/index.html'
    }
  }
  /**
  * Determine host url for the resource
  * @param  {Object} resourceInfo
  * @return {String}
  */
  var items_use_openflc4 = [];//[515, 517, 518]
  var determineHostUrl = function (resourceInfo) {
    var resourceHostUrl;
    var remoteName = resourceInfo.content.name || resourceInfo.slug;
    if(items_use_openflc4.indexOf(resourceInfo.id) > -1){
     resourceInfo.content.container = 'openfl_c4';
    }
    var triggerDebug = DEV_VARIABLES.LOGGING_OVERRIDE.RESOURCE;
    // $log.debug(determineURLForOpenFl(remoteName, resourceInfo.content.version) + ( triggerDebug ?  '&debug=true' : ''));
    switch (resourceInfo.content.container) {
      case 'openfl': return determineURLForOpenFl(remoteName, resourceInfo.content.version) + ( triggerDebug ?  '&debug=true' : '')
      case 'c4swf': return determineURLForCycle4(remoteName, resourceInfo.content);
      case 'html_package': return determineURLForHTMLPackage(remoteName, resourceInfo.content.version)
      case 'inbook_package': return determineURLForInbook(remoteName, resourceInfo.content.version)
      case 'itematic_package': return determineURLForItematic(remoteName, resourceInfo.content.itematicGroupId, resourceInfo.content.itematicGroupItemId, resourceInfo.content.itemVersionId)
      case 'openfl_c4': return determineURLForCycle4Html(remoteName, resourceInfo.content);
      case 'module': return null;
      case 'link': return determineURLForLink(resourceInfo.content);
      default: return determineURLForOpenFl(remoteName, resourceInfo.content.version || null) + ( triggerDebug ?  '&debug=true' : '')
      // $log.warn('No container type for', resourceInfo.slug, 'using openfl as default.')
    }
  };

  /**
  * Compute locks and completions from module map and work.
  * This will also set the hostUrl variable
  * @param  {Array<StudentWork>} studentWorks
  * @param  {Array<Resource>} moduleResources
  * @return {Array<ResourceWithWork>}
  */
  var computeResourceStatusForStudentWork = function (studentWorks, moduleResources, skip_determination_step) {
    $log.debug('[[StudentDataService]] computeResourceStatusForStudentWork', studentWorks, moduleResources, skip_determination_step)
    /**
    * Determines if a resource is complete.
    * This will set the `complete` flag on a resource
    * @param  {ModuleResource} resource
    * @return {Null}
    */
    var determineIfComplete = function (resource) {
      if(!skip_determination_step){
        var workBatch = studentWorks.filter(function (studentWork) {
          return studentWork.WorkBatch.resource_id === resource.id
        })
        resource.hostUrl = determineHostUrl(resource)
        resource.content.hostUrl = resource.hostUrl;
        if (workBatch.length > 0) {
          resource.resourceState = {};
          resource.resourceState.completions = 0;
          resource.resourceState.complete = false;
          resource.resourceState.score_max = 0;
          workBatch.forEach(function(batch){
            if(!batch.WorkBatch.StudentResourceState){
              batch.WorkBatch.StudentResourceState = {completions:0, complete:false, score_max:0}
            }
            resource.complete = resource.complete || batch.WorkBatch.StudentResourceState.completions > 0;
            resource.resourceState.completions += batch.WorkBatch.StudentResourceState.completions;
            resource.resourceState.complete = resource.resourceState.complete || batch.WorkBatch.StudentResourceState.complete;
            resource.resourceState.score_max = Math.max(resource.resourceState.score_max, batch.WorkBatch.StudentResourceState.score_max);
  
          })
        }else {
          resource.complete = false;
        }
      }      
    }

    if(moduleResources.length > 0 && moduleResources[0].slug.indexOf('ocmt_hse') > -1){
      //This orders resources based on their unlock_by ordering, which is needed for cutoff scoring implementation in ocmt
      //techincally running for everything should make no difference, but just to be safe filtered for ocmt_hse items
      moduleResources = moduleResources.sort(function(b,a){
        if(a.unlocked_by && a.unlocked_by.length > 0 && a.unlocked_by.indexOf(b.slug) > -1){
          return -1;
        }else{
          return 0;
        }
      })
    }
    
    /**
    * Array<ResourceWithWork>
    */
    return moduleResources.map(function (resource) {
      switch (resource.resource_type) {
        case 'sub_module'://Depreacted, Use 'module' instead. Only here for backwards compatibilty (once we get to LIVE, it will be removed)
        resource.children = computeResourceStatusForStudentWork(studentWorks, resource.children || [], skip_determination_step);
        break;
        case 'module':
        resource.children = computeResourceStatusForStudentWork(studentWorks, resource.children || [], skip_determination_step);
        break;
        case 'resource_module':
        resource.children = computeResourceStatusForStudentWork(studentWorks, resource.children || [], skip_determination_step);
        break;
        case 'lesson_module'://Depreacted, Use 'resource_module' instead. Only here for backwards compatibilty (once we get to LIVE, it will be removed)
        resource.children = computeResourceStatusForStudentWork(studentWorks, resource.children || [], skip_determination_step);
        break;
        case 'symlink':
        break;
        // case 'assessment': //do same as lesson
        //       $log.debug('Processing', resource.slug, 'as assessment')
        // case 'lesson': //do same as default
        //       $log.debug('Processing', resource.slug, 'as lesson')
        default:// Do this for assessments and lessons, i.e. "leafs"
        if (!resource.workBatch) {
          determineIfComplete(resource)
        }
        
        resource.locked = resource.unlocked_by.filter(function (requiredResourceSlug) {
          var requiredResource = moduleResources.filter(function (someResourceFromMap) {
            return someResourceFromMap.slug === requiredResourceSlug
          })
          // $log.log('moduleResources: ' , resource.slug, resource.unlocked_by, requiredResource)
          if (requiredResource.length === 0) {
            $log.warn('resource.unlocked_by', resource.unlocked_by)
            //throw 'Could not find required, ' + requiredResourceSlug + ', resource for ' + resource.slug;
          } else if (requiredResource.length > 1) {
            $log.warn('Found too many required, ' + requiredResourceSlug + ', resource for ' + resource.slug)
            throw 'Found too many required, ' + requiredResourceSlug + ', resource for ' + resource.slug;
          } else {
            requiredResource = requiredResource[0]
            
            if (!requiredResource.resourceState) {              
              determineIfComplete(requiredResource)
            }

            // if(requiredResource.config.unlock_score){
            //   var unlockResource = requiredResource;
            //   if(resource.config.unlock_by_score_slug){
            //     unlockResource = moduleResources.filter(function (someResourceFromMap) {
            //       return someResourceFromMap.slug === resource.config.unlock_by_score_slug
            //     })
            //     unlockResource = unlockResource.length > 0 ? unlockResource[0] : requiredResource;
            //     if (!unlockResource.resourceState) {              
            //       determineIfComplete(unlockResource)
            //     }
            //   }

            //   if(unlockResource.resourceState){
            //     if(unlockResource.resourceState.score_max < unlockResource.config.unlock_score){
            //       return !requiredResource.complete;
            //     }else if(resource.config.assessment_type === 'summative'){
            //       return resource.complete;
            //     }
            //     resource.resourceState = {};
            //     resource.resourceState.completions = Math.max(1, resource.resourceState.completions || 0);
            //     resource.resourceState.complete = true;
            //     resource.resourceState.score_max = 1;
            //     resource.complete = true;
            //     return false;
            //   }
            // }

            if(requiredResource.resource_type && requiredResource.resource_type === "assessment"){
              return !requiredResource.complete;
            }

            if(requiredResource.display && requiredResource.display.color === 'blue'){
              return !requiredResource.complete;
            }
            if(requiredResource.slug.indexOf('run_like_math') > -1){
              return requiredResource.resourceState ? requiredResource.resourceState.score_max === 0 || !requiredResource.complete : true
            }
            return requiredResource.resourceState ? requiredResource.resourceState.score_max < 0.8 : true//!requiredResource.complete
          }
        });
        resource.locked = resource.locked.length > 0;
        break;
      }

      if(resource.resource_type === 'assessment'){
        if(resource.config.assessment_type === 'summative' || resource.config.assessment_type === 'formative'){
          resource.locked = resource.complete || resource.locked;
        }else{
          resource.locked = resource.complete;
        }      
      }else if(resource.complete){
        resource.locked = false;
      }

      /**
      * ResourceWithWork
      */
      return resource;
    })
  }

  /**
  * Gets the work in a module a student
  * @param  {Module} moduleResource
  * @return {Promise<ModuleWithWork>}
  */
  var getStudentWorkForModule = function (moduleResource) {
    if (!moduleResource) {
      $log.debug("trying to getStudentWorkForModule, but no module resource found")
      return $q.when(null);
    }
    return api.getStudentModuleResourceState(moduleResource.module_id).
    then(function (studentWorks) {
      /**
      * ModuleWithWork
      * @param {String} module_id
      * @param {Array<ResourceWithWork>} resources
      */
      return {
        hostUrl: moduleResource.Resource.content ? determineHostUrl(moduleResource.Resource) : null,
        resource_slug: moduleResource.Resource.slug,
        module_id: moduleResource.module_id,
        resources: computeResourceStatusForStudentWork(studentWorks, moduleResource.Resource.children),
      }
    })
  }

  /**
  * Get the student map and pull the work
  * @param {Boolean}  refresh fresh pull
  * @return {Promise<Map<String,ModuleWithWork>>}
  */
  var getStudentMaps = function (refresh) {
    if (Object.keys(studentModuleMaps).length === 0 || refresh) {
      return api.getClassModuleMaps().then(function (moduleMaps) {
        //   overrideC3itemMaps(moduleMaps); // this function was commented out, please see `determineURLForOpenFl` for the way we should overrides!
        return $q.all([ // I made it so it always grabs the first module, sub_modules should assigned to the parent!
          getStudentWorkForModule(moduleMaps.Modules[0]).then(function (moduleWithWork) {
            studentModuleMaps = moduleWithWork;
            studentModuleMaps.meta_config = moduleMaps.Modules && moduleMaps.Modules.length > 0 ? moduleMaps.Modules[0].Resource.config : null;
            studentModuleMaps.content = moduleMaps.Modules && moduleMaps.Modules.length > 0 ? moduleMaps.Modules[0].Resource.content : null;
            return;
          })
        ])
      }).
      then(function (modules) {
        if(studentModuleMaps.module_id === 11){
          studentModuleMaps = moduleMappingService.getC3Mapping(studentModuleMaps)
          _.each(studentModuleMaps.resources, function(submod){
            submod.children = computeResourceStatusForStudentWork({}, submod.children, true)
          }) 
        }
        return studentModuleMaps;
      })
    } else {
      return $q(function (resolve) {
        resolve(studentModuleMaps)
      })
    }
  }

  // This is not how we do this, please see the `determineURLForOpenFl` function
  // It has a very clear way on how to override the versions!!!
  // var overrideC3itemMaps = function(pack){
  //     // var overrides = {
  //     //   "mtic_c3_m1_plane": "MRek3KGkF.Ue16dat72ivBhNL.pOSJZh",
  //     //   "mtic_c3_m1_airport": ".hkmR5hEXgfnDZckAYO3jby9Y127SYyO",
  //     //   "mtic_c3_m1_bus": "mD01c4prTZP2QBZJs3nBfqTKjX9eypgt",
  //     //   "mtic_c3_m1_monkey": "j84tgQOxBOBNN_7ceb3SR1u1vLM4CkzE",
  //     //   "mtic_c3_m1_flamingo": "U18F5ClpTJHrrtLJQ.5XxmmiuG_cDt9M"
  //     // }
  //     _.each(pack.Modules, function(module){
  //       $log.debug('overrideC3itemMaps', module, module.Resource.slug);
  //       if (module.Resource.slug == "mtic_c3_m1"){
  //         _.each(module.Resource.children, function(resource){
  //           if (resource.name){
  //             resource.name = resource.name.split(' ')[0];
  //           }
  //           if (resource.slug == 'mtic_c3_m1_plane'){
  //             $log.debug(resource.slug, resource.content.version)
  //           }
  //         })
  //       }
  //     })
  //   }
  /**
  * Generates a module with work
  * @param  {StudentWork} studentWorks
  * @param  {ModuleResource} moduleResource
  * @return {ModuleWithWork}
  */
  var genModuleWIthWork = function(studentWorks, moduleResource, user_id) {
    /**
    * ModuleWithWork
    * @param {String} module_id
    * @param {String} hostUrl
    * @param {String} resource_slug
    * @param {Array<ResourceWithWork>} resources
    */
    return {
      class_id: moduleResource.GroupModule.group_id,
      hostUrl: moduleResource.Resource.content ? determineHostUrl(moduleResource.Resource) : null,
      resource_slug: moduleResource.Resource.slug,
      module_id: moduleResource.module_id,
      resources: computeResourceStatusForStudentWork(studentWorks, moduleResource.Resource.children),
      meta_config: moduleResource.Resource.config,
      content: moduleResource.Resource.content
    }
  }
  StudentDataService.genModuleWIthWork = genModuleWIthWork;
  return StudentDataService;
})
